export type LinkRequestFailure = 'throttled' | 'captcha' | 'other';

const FALLBACK_MESSAGE = 'Something went wrong. Try again.';

// The sdk rejects a 400 with field errors as the bare `{ field: [message] }` body.
const getFirstFieldError = (error) => {
  if (!error || error instanceof Error || typeof error !== 'object') {
    return undefined;
  }

  const [first] = Object.values(error).flat();
  return typeof first === 'string' ? first : undefined;
};

// The sdk drops the status code, so the text of the body is the only way to tell the cases
// apart: DRF's 429 is `{ detail: "Request was throttled. ..." }`, and the captcha refusal is
// the one message of the API that has "CAPTCHA" in it.
export const getLinkRequestError = (error): { reason: LinkRequestFailure; message: string } => {
  if (String(error?.detail ?? '').startsWith('Request was throttled')) {
    return { reason: 'throttled', message: 'Too many requests. Try again later.' };
  }

  const text = typeof error?.message === 'string' ? error.message : getFirstFieldError(error);

  // A 5xx from the proxy arrives as a page of HTML.
  if (!text || text.trimStart().startsWith('<')) {
    return { reason: 'other', message: FALLBACK_MESSAGE };
  }

  return { reason: text.includes('CAPTCHA') ? 'captcha' : 'other', message: text };
};
